import { ButtonProps, IconButton, } from '@chakra-ui/react';
import IconAddCircle from 'assets/icons/icon-add-circle.svg?react';
import { LinkProps } from 'react-router-dom';

type IconButtonCreateProps = ButtonProps & Partial<LinkProps>;

export default function IconButtonCreate(props: IconButtonCreateProps) {
  return (
    <IconButton 
      aria-label="Criar"
      size="sm"
      variant="primary"
      icon={<IconAddCircle />}
      {...props}
    />
  )
}
